module.exports = __webpack_public_path__ + "static/media/bg.acf77b48.jpg";